export default __webpack_public_path__ + "static/5-1125dbbe5b3debafa55db0ea172d7900.svg";